import * as React from 'react';
/**
 *
 * Original name: unknown
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29157%3A6737
 *
 */
export const UnknownPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 14c-8.483 0-12.738 3.741-12.988 11.43C12.387 27.032 8 29.825 8 33c0 2.458 2.627 4.685 6.885 6.31l-2.7 5.852 3.63 1.676 2.925-6.335c3.277.816 7.12 1.338 11.26 1.466V50h4v-8.03c4.14-.129 7.983-.651 11.26-1.467l2.924 6.335 3.632-1.676-2.701-5.853C53.373 37.685 56 35.458 56 33c0-3.176-4.387-5.968-11.012-7.57C44.738 17.741 40.483 14 32 14Zm-7.047 5.933C23.883 20.934 23 22.728 23 26.163v1.244a21.001 21.001 0 0 0 18 0v-1.244c0-3.435-.883-5.229-1.953-6.23C37.925 18.883 35.849 18 32 18s-5.925.883-7.047 1.933Z", fill: "currentColor" })));
